import React from 'react'

interface Props {
  title: string
}

const ModuleWrapper: React.FC<Props> = (props) => {
  return (
    <div className="card mb-2">
      <h2 className="card-header">{props.title}</h2>
      <div className="card-block">{props.children}</div>
    </div>
  )
}

export default ModuleWrapper
